import { PresentationIcon } from '@shared/assets';

import * as st from './index.module.scss';

const Presentation = ({ presentation }) => {
	return (
		 <a className={st.container} href={presentation} target="_blank" rel="noreferrer">
			<div className={st.title}>Смотреть презентацию</div>
			<div className={st.icon}>
				<PresentationIcon />
			</div>
		</a>
	);
};

export default Presentation;
